<div class="container container-wrapper h-75">
  <div class="row h-100 justify-content-center align-items-center text-center">
    <div class="col-12 col-xl-11">
      <h3 class="pb-2">{{ 'Thanks for your booking' | translate }}</h3>
      <section class="col offset-md-4 col-md-4 mt-5">
        <div class="art-box">
          <a (click)="onNext()">
            <h3>{{ 'Next' | translate }}</h3>
          </a>
        </div>
      </section>
    </div>
  </div>
</div>
